import React, { useState, useEffect } from "react";
import "../styles/TopNavbar.css";

function TopNavbar() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    "⭐️⭐️⭐️⭐️⭐️ 720+ clients ravis !",
    "🔥 Livraison GRATUITE partout en Tunisie pour 2 cadres achetés ! 🇹🇳",
    "🔥 Achetez 3 cadres et payez seulement 130 DT + Livraison GRATUITE 🇹🇳"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <div className="top-navbar">
      <div className="container text-center position-relative">
        <div className="carousel-content">
          {slides[currentSlide]}
        </div>

        <div className="custom-nav">
          <div className="custom-prev" onClick={goToPrevious}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="custom-next" onClick={goToNext}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopNavbar;